import { render, staticRenderFns } from "./OrderDraftPage.vue?vue&type=template&id=73e88914&"
import script from "./OrderDraftPage.vue?vue&type=script&lang=ts&"
export * from "./OrderDraftPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports